import { EPaymentType } from '@/enums';
import { IAddress, ICardInfo, ICardPost, IPagarmeCardForm } from '@/interfaces';
import PaymentService from '@/services/PaymentService';
import { computed, ref } from 'vue';
import usePayment from './usePayment';
import useToast from './useToast';

export default function useCards() {
  const { toastSuccess, toastError } = useToast()
  const {
    currentPaymentMethod,
    savePaymentMethod,
    removePaymentMethod,
    setDefaultPaymentMethod,
  } = usePayment()


  const lastSelectedCard = computed(() => currentPaymentMethod.value?.card_info || creditCards.value[0] || null)

  const creditCards = ref<ICardInfo[]>([])
  const loading = ref(false)
  const submitting = ref(false)

  const getCards = async () => {
    try {
      const res = await PaymentService.listCards()
      creditCards.value = res
      setDefaultPaymentMethod(lastSelectedCard.value)
    } catch (error) {
      console.log('usePayment.getCards', error)
    } finally {
      loading.value = false
    }
  }

  const removeCard = async (card: ICardInfo) => {
    try {
      submitting.value = true
      const res = await PaymentService.removeCard(card.id)
      creditCards.value = creditCards.value.filter(c => c.id != card.id)
      if (card.id == currentPaymentMethod.value?.card_info?.id) {
        removePaymentMethod()
      }
      toastSuccess('Cartão removido!')
    } catch (error) {
      console.log('usePayment.removeCard', error)
    } finally {
      submitting.value = false
    }
  }
  const createCardToken = async (cardForm: any) => {
    try {
      const cardParams: IPagarmeCardForm = {
        holder_name: cardForm.holder_name,
        number: cardForm.number,
        exp_month: cardForm.exp_month,
        exp_year: cardForm.exp_year,
        cvv: cardForm.cvv,
      }
      const res = await PaymentService.createCardToken(cardParams)
      if (!res.id) {
        throw ('Dados do cartão inválidos. Confira as informações do seu cartão e tente novamente')
      }
      return res.id
    } catch (error) {
      console.log('usePayment.createCardToken', error)
      throw (error)
    }
  }
  const createCard = async (address: IAddress, cardForm: any, onSuccess: () => void) => {
    try {
      submitting.value = true
      const token = await createCardToken(cardForm)
      const params: ICardPost = {
        address: {
          zip_code: address.zip_code,
          city: address.city,
          state: address.state,
          country: address.country,
          line_1: address.street
        },
        token,
        document_number: cardForm.document_number
      }
      const cardRes = await PaymentService.createCard(params)
      savePaymentMethod({ payment_type: EPaymentType.credit_card, card_info: cardRes })
      toastSuccess('Cartão criado com sucesso')
      onSuccess()
    } catch (error: any) {
      toastError(error)
      console.log('usePayment.createCard', error)
    } finally {
      submitting.value = false

    }
  }

  return {
    currentPaymentMethod,
    getCards,
    creditCards,
    savePaymentMethod,
    removeCard,
    removePaymentMethod,
    createCard,
    loading,
    submitting,
    lastSelectedCard
  }
}
